import HomeSlider from "./Homeslider";
import CategorySection from "../Category/category";
// import Recipes from "../Recipes/Recipes";
// import HeroRecipe from "../HeroRecipe/HeroRecipe";
import Contact from "../Contact/Contact";
import IngredientSearch from "../SearchByIngrediants/IngredientSearch";

function Home() {
  return (
    <>
      <HomeSlider />
      <IngredientSearch />
      <CategorySection />
      {/* <Recipes /> */}
      {/* <HeroRecipe /> */}
      <Contact />
    </>
  );
}

export default Home;